var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrophy01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 12.5a5 5 0 0 1-5-5V2.87c0-.344 0-.517.05-.655a.833.833 0 0 1 .499-.498c.138-.05.31-.05.655-.05h7.593c.345 0 .517 0 .655.05a.833.833 0 0 1 .498.498c.05.138.05.31.05.656V7.5a5 5 0 0 1-5 5zm0 0V15m5-11.666h2.084c.388 0 .582 0 .735.063a.833.833 0 0 1 .451.451c.064.153.064.347.064.736V5c0 .775 0 1.163-.085 1.48a2.5 2.5 0 0 1-1.768 1.768c-.318.086-.706.086-1.48.086m-10-5H3.416c-.388 0-.582 0-.736.063a.833.833 0 0 0-.45.451c-.064.153-.064.347-.064.736V5c0 .775 0 1.163.085 1.48A2.5 2.5 0 0 0 4.02 8.249c.318.086.705.086 1.48.086m1.204 10h7.593a.37.37 0 0 0 .37-.37A2.963 2.963 0 0 0 11.704 15H9.297a2.963 2.963 0 0 0-2.963 2.963c0 .205.165.37.37.37z",
    stroke: "#667085",
    strokeWidth: 1.667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy01);
export default __webpack_public_path__ + "static/media/trophy01.c0d54c68cd848db6b10d3185095e8572.svg";
export { ForwardRef as ReactComponent };